import React, { useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import ReactCodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';

interface ScriptTestDetailModalProps {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
}

const ScriptTestDetailModal: React.FC<ScriptTestDetailModalProps> = ({
  open,
  title,
  content,
  onClose,
}) => {
  const formattedContent = useMemo(() => {
    try {
      return JSON.stringify(JSON.parse(content), null, 2);
    } catch {
      return content;
    }
  }, [content]);

  const extensions = useMemo(() => [json()], []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <ReactCodeMirror
          value={formattedContent}
          height="400px"
          extensions={extensions}
          editable={false}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScriptTestDetailModal;
